// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"528fb3d6","455":"dc3adc4e","977":"32d75937"}[chunkId] + ".chunk.js";
};